module.exports = __webpack_public_path__ + "static/media/datepicker2.b57ccc8f.svg";